import SearchDialog from 'Components/SearchDialog';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from 'Store/index';
import { actions } from 'Store/session';

const MedicationSearchDialog = ({ formData, disabled, disabledTooltip }: IOwnProps): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const medicationFetch = (searchString: string) => actions.medicationSearch(dispatch, searchString);

  const status = useAppSelector(s => s.session.medicationSearchStatus);

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <SearchDialog
      formData={formData}
      searchFn={medicationFetch as unknown as (s: string) => Promise<Array<Record<string, string>>>}
      resultToDoc={{
        name: 'medicationName',
        atc: 'atc',
        substanceString: 'medicationSubstances',
        dosageForm: 'dosageForm',
      }}
      openCloseButton={{ disabled, disabledTooltip }}
      openCloseButtonText={'medication.chooseMedication'}
      title={'medication.chooseMedication'}
      info={'medication.medDialogInfoText'}
      loading={status === 'loading'}
      errorMsg={status === 'failed' ? fm('general.medicationSearchFailedMessage') : null}
    />
  );
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'medication'>>;
  disabled?: boolean;
  disabledTooltip?: React.JSX.Element;
}

export default MedicationSearchDialog;
